import React from 'react'
import styles from './ActionBar.module.css'
import CustomTooltip from '../CustomTooltip'

const ActionBar = ({
  onOpenTextEditor,
  onShowCodeEditor,
  onOpenUrl,
  isMobile,
  viewRepos,
  onOpenGithubModal,
  onOpenTransferRequestLinkModal
}) => {
  return (
    !isMobile && (
      <div className={styles.actionBarContainer}>
        <div className={styles.iconSection}>
          <CustomTooltip label="Paste Code">
            <button className={`${styles.iconItem} tr-create-code`} onClick={onShowCodeEditor}>
              <img src="/assets/icons/code-bracket.svg" alt="code-bracket" height="20" width="20" />
            </button>
          </CustomTooltip>
          <CustomTooltip label="Write Text">
            <button className={`${styles.iconItem} tr-create-text`} onClick={onOpenTextEditor}>
              <img src="/assets/icons/text-icon.svg" alt="text-icon" height="20" width="20" />
            </button>
          </CustomTooltip>
          <CustomTooltip label={viewRepos ? 'View Repositories' : 'Deploy from GitHub'}>
            <button className={`${styles.iconItem} tr-create-gh`} onClick={viewRepos ? onOpenGithubModal : onOpenUrl}>
              <img src="/assets/icons/github.svg" alt="github-icon" height="20" width="20" />
            </button>
          </CustomTooltip>
          <CustomTooltip label="Create Shared Project">
            <button className={`${styles.iconItem} tr-shared-project`} onClick={onOpenTransferRequestLinkModal}>
              <img src="/assets/icons/transfer-request-link.svg" alt="transfer-request-link" height="20" width="20" />
            </button>
          </CustomTooltip>
        </div>
      </div>
    )
  )
}

export default ActionBar
